<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.title' :placeholder="$t('商品标题') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.game_type_id' clearable
                                                      :placeholder="$t('商品分类') " style='width:120px'>

              <Option :key="key" :value="value.id.toString()"
                      v-for="(value, key) in extraParams"> {{ value.title }}
              </Option>

            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.is_lock' clearable
                                                      :placeholder="$t('是否锁定') " style='width:120px'>
              <Option :value="'0'">{{ $t('否') }}</Option>
              <Option :value="'1'">{{ $t('是') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'gameManage/GoodsList/add'" @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">


        <FormItem style="margin-bottom:4px" label='标题' prop='title'>
          <Input v-model='windowAddItem.title' :placeholder="$t('请输入标题')" style="width: 400px"></Input>
          <internationality v-if="windowAddItem.id" :keyword="'game_goods|title|'+windowAddItem.id"
                            type='string'></internationality>
        </FormItem>

        <FormItem label='商品类型' prop='game_type_id'>
          <Select clearable v-model='windowAddItem.game_type_id' style='width:200px'>
            <Option :key="key" :value="value.id.toString()"
                    v-for="(value, key) in extraParams"> {{ value.title }}
            </Option>
          </Select>
        </FormItem>

        <FormItem style="margin-bottom:4px" label='大图' prop='pic'>
          <!--          <Input v-model='windowAddItem.pic' :placeholder="$t('请输入活动图片')"></Input>-->
          <div class="demo-upload-list" v-if="windowAddItem['pic']">
            <img :src="windowAddItem['pic']" style="max-width: 300px;max-height: 300px">
            <div class="demo-upload-list-cover">
              <Icon type="ios-trash-outline" @click.native="handleImgRemove('pic')"></Icon>
            </div>
          </div>
          <input v-if="windowAddItem['pic']" v-model="windowAddItem['pic']" type="hidden" name="image">
          <Upload type="drag"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  v-if="!windowAddItem['pic']"
                  :format="['jpg','jpeg','png','gif']"
                  :max-size="5120"
                  :on-success="handleImgSuccess"
                  :on-format-error="handleImgFormatError"
                  :on-exceeded-size="handleImgMaxSize"
                  style="display: inline-block;width:58px">
            <div style="width: 58px;height:58px;line-height: 58px">
              <Icon type="md-camera" size="20"></Icon>
            </div>
          </Upload>
          <internationality v-if="windowAddItem.id" :keyword="'game_goods|pic'+windowAddItem.id"
                            type='image'></internationality>
        </FormItem>

        <FormItem label='商品价格' prop='price'>
          <Input clearable v-model='windowAddItem.price' :placeholder="$t('请输入商品价格')"></Input>
        </FormItem>

        <FormItem style="margin-bottom:4px" label='商品详情' prop='body'>
          <!--          <Input v-model='windowAddItem.body' :placeholder="$t('请输入文章内容')"></Input>-->
          <div>
            <textarea id="ck-editor" name="ckeditor" rows="10" cols="80"></textarea>
          </div>
          <internationality v-if="windowAddItem.id" :keyword="'game_goods|body|'+windowAddItem.id"
                            type='editor'></internationality>
        </FormItem>


        <FormItem label='是否锁定' prop='is_lock'>
          <Select clearable v-model='windowAddItem.is_lock' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('正常') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('锁定') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/gameManage/GoodsList'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

import { baseUrl } from '@/libs/api.request'
import { getToken } from '@/libs/util'

import CKEDITOR from 'CKEDITOR'
import internationality from '@/components/internationality'

export default {
  name: 'interface_list',
  components: {
    internationality
  },
  data () {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: { 'Api-Auth': getToken() },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('标题'),
        key: 'title',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('商品类型'),
        key: 'game_type_id_name',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('商品价格'),
        key: 'price',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('是否锁定'),
        align: 'center',
        minWidth: 100,

        key: 'is_lock',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_lock ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_lock ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_lock ? this.$t('锁定') : this.$t('正常')),
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {

                let vm = this
                vm.windowAdd.show = true
                vm.windowAddItem.title = params.row.title
                vm.windowAddItem.id = params.row.id
                vm.windowAddItem.body = params.row.body
                vm.windowAddItem.is_lock = params.row.is_lock.toString()
                vm.windowAddItem.pic = params.row.pic.toString()
                vm.windowAddItem.price = params.row.price
                this.editorObj1.setData(params.row.body)
                vm.windowAddItem.game_type_id = params.row.game_type_id.toString()
                vm.windowAdd.show = true

              }
            }
          }, this.$t('修改')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ]),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        pic: ''
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('gameManage/GoodsList/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('gameManage/GoodsList/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('gameManage/GoodsList/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getParams()
    this.initializeEditor()
  },
  methods: {
    initializeEditor () {
      this.editorObj1 = CKEDITOR.replace('ckeditor', {
        language: 'zh-CN',      // Adding drag and drop image upload.
        removeDialogTabs: 'image:advanced;image:Link',
        image_previewText: '  ',
        extraPlugins: 'uploadimage',
        uploadUrl: this.uploadUrlCk,
        filebrowserImageUploadUrl: this.uploadUrlCk,
        filebrowserUploadUrl: this.uploadUrlCk, //服务器上传地址
        removeButtons: 'Save,PasteFromWord,PasteText,Paste,Copy,Replace,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BulletedList,NumberedList,Indent,Outdent,Language,About,ShowBlocks,Flash,Anchor,HorizontalRule,PageBreak,Iframe'
      })

      // 图片上传返回的数据处理
      this.editorObj1.on('fileUploadResponse', function (evt) {
        evt.stop()
        var data = evt.data
        let xhr = data.fileLoader.xhr
        let response = xhr.responseText
        let imgUrl = JSON.parse(response).data.fileUrl
        if (!imgUrl) {
          data.message = '上传出错'   // 这是失败alert提示信息
          evt.cancel()
        } else {
          data.url = imgUrl   // 返回到“图像信息”那里的URL框里面
        }
      })
    },
    preAdd () {
      let vm = this
      vm.windowAddItem.id = 0
      vm.windowAddItem.title = ''
      vm.windowAddItem.is_lock = '0'
      this.editorObj1.setData('')
      vm.windowAddItem.pic = ''
      vm.windowAddItem.price = '1'
      vm.windowAddItem.game_type_id = 1
      vm.windowAdd.show = true
    },
    getParams () {
      getParams().then(response => {
        this.extraParams = response.data.data.gameTypes
      })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          this.windowAddItem.body = this.editorObj1.getData()
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    }, handleImgFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove (key) {
      this.windowAddItem[key] = ''
    },
    handleImgSuccess (response) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        this.windowAddItem.pic = response.data.fileUrl
        //由于字段是动态的，所以查找一下 图片字段，再显示
        // for (let key in this.windowAdd.windowsParams2) {
        //   if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
        //     this.windowAddItem[key] = response.data.fileUrl
        //   }
        // }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize (file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
  }
}
</script>
